import React, { useState,useEffect } from 'react';
import CustomInput from '../../components/CustomInput';
import '../../assets/css/Login.css';
import CustomButton from '../../components/CustomButton';
import { FcGoogle } from "react-icons/fc";
import loginImage from '../../assets/images/tennis-court.webp';
import { useNavigate } from 'react-router-dom';
import { apiHandler } from '../../assets/api';
import { endpoint } from '../../assets/api/endpoint';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { saveToken, saveUserId, saveUserAuthId, saveLoggedIn, saveProfileData } from '../../redux/UserDataSlice';
import { useDispatch } from "react-redux";
import { GoogleLogin } from '@react-oauth/google';
import { useSelector } from 'react-redux';
import GoogleSignInButton from '../../components/GoogleSignInButton';
import { useSearchParams } from 'react-router-dom';


const LogIn = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userId } = useSelector((state) => state.loginInfo);
  const { accessToken } = useSelector((state) => state.loginInfo);
  const [params] = useSearchParams();
  const email = params.get('emailOrPhone');
  const pwd = params.get('password');
  const [form, setForm] = useState({ emailOrPhone: '', password: '' });

  
  useEffect(() => {
    if (email) setForm(f => ({ ...f, emailOrPhone: email }));
    if (pwd) setForm(f => ({ ...f, password: pwd }));
  }, [email, pwd]);

  const [formData, setFormData] = useState({
    emailOrPhone: '',
    password: '',
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    let message = '';

    if (name === 'emailOrPhone') {
      if (!value.trim()) {
        message = 'Email or Phone Number is required';
      } else if (value.includes('@')) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) {
          message = 'Please enter a valid email address';
        }
      } else if (!/^\d{10}$/.test(value)) {
        message = 'Please enter a valid 10-digit phone number';
      }
    }

    if (name === 'password') {
      if (!value.trim()) {
        message = 'Password is required';
      }
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: message,
    }));
  };

  const validateInputs = () => {
    const newErrors = {};
    const { emailOrPhone, password } = formData;

    if (!emailOrPhone.trim()) {
      newErrors.emailOrPhone = 'Email or Phone Number is required';
    } else if (emailOrPhone.includes('@')) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(emailOrPhone)) {
        newErrors.emailOrPhone = 'Please enter a valid email address';
      }
    } else if (!/^\d{10}$/.test(emailOrPhone)) {
      newErrors.emailOrPhone = 'Please enter a valid 10-digit phone number';
    }

    if (!password.trim()) {
      newErrors.password = 'Password is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onLogInSubmit = async (e) => {
    if (e) e.preventDefault();

    if (!validateInputs()) return;

    setLoading(true);

    try {
      const data = {
        email: formData.emailOrPhone.toLowerCase(),
        password: formData.password,
      };

      const result = await apiHandler({
        url: endpoint.SIGN_IN,
        method: "POST",
        data: data,
      });

      if (result?.data?.accessToken) {
        dispatch(saveToken({ accessToken: result.data.accessToken }));
        dispatch(saveUserId(result.data.userId));
        dispatch(saveUserAuthId(result.data.authId));
        dispatch(saveLoggedIn(true));
        toast.success('Login Successful');
        if (result?.data?.isOnboarded) {
          navigate('/explore');

        } else if ((result?.data?.isPreOnboarded) && !(result?.data?.isOnboarded)) {
          navigate('/subscription')
        } else {
          navigate('/personalise');
        }
      } else {
        toast.error(result?.data?.user_description || 'Invalid email or password');
      }
    } catch (error) {
      toast.error(error?.message || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const onRegisterNow = () => navigate('/register');
  const onForgetPassword = () => navigate('/forget-password');

  return (
    <>
      <div >
        <img src={loginImage} alt='' className='Image-LogIn' />
      </div>
      <div className='bg-login login-Wrapper'>
        <div className='container'>
          <div className='row cont-log-in-container d-flex justify-content-center align-items-center ' >
            <div className='col-lg-6 co-sm-12 log-In-container'>
              <form
                className='form-wrapper'
              >
                <div className='text-start fw-bolder fs-4 sign-up-text ps-3'>Log In</div>
                <div className='input-button-container'>
                  <CustomInput
                    name='emailOrPhone'
                    label="Email or Phone Number"
                    placeholder="Email or Phone Number"
                    type='text'
                    value={formData.emailOrPhone}
                    className={errors.emailOrPhone ? 'input-error' : ''}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  />
                  {errors.emailOrPhone && <div className="text-danger">{errors.emailOrPhone}</div>}
                </div>

                <div className='input-button-container'>
                  <CustomInput
                    name='password'
                    label="Password"
                    placeholder="Password"
                    type='password'
                    value={formData.password}
                    className={errors.password ? 'input-error' : ''}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  />
                  {errors.password && <div className="text-danger">{errors.password}</div>}
                </div>

                <div className='mt-3 text-end'>
                  <span className='forget-pass-text' onClick={onForgetPassword}>Forgot password?</span>
                </div>

                <div className='logIn-button-container text-center'>
                  <CustomButton
                    buttonText={loading ? 'Logging in...' : 'Login'}
                    className={'login-button'}
                    type="submit"
                    disabled={loading}
                    onClick={()=>onLogInSubmit()}
                  />
                </div>

                <div className="line-wrapper">
                  <div className="line-text">Or</div>
                </div>

                <div className=' logIn-google-btn-wrapper mt-2 ms-3 me-3 d-flex justify-content-center'>
                  <GoogleSignInButton
                    showDefaultButton={false}
                    buttonText="Sign in with Google"
                    customButtonStyle={{ backgroundColor: '#4285f4', color: 'white' }}
                    onSuccess={(data) => console.log('Success:', data)}
                    onError={(error) => console.log('Error:', error)}
                  />
                </div>

                <div className='logIn-register-text'>
                  Not a member? <span className='login-reg-now-txt' onClick={onRegisterNow}>Register now</span>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LogIn;
